import { axiosClient } from "services/axios";

export function deletePriceListItem(pricelistid: string) {
  return axiosClient.delete("stores/pricelist", {
    params: { pricelistid },
  });
}
